import { LocalNotFoundError } from '../general.errors';

export class MediaRecorderNotFoundError extends LocalNotFoundError {
    constructor(message: string) {
        super(message);
        this.name = 'MediaRecorderNotFoundError';
    }
}
